module.exports = __webpack_public_path__ + "static/media/personal_folder_tip_2.79d73495.png";